import {FinancingStatusResponseBodySaleVehiclePhoto} from '@dms/api/vehicle';

// A PENDING card renders asynchronously on the BE; the gallery polls until no visible card waits.
export const hasPendingFinancingPromo = (
  financingStatus: FinancingStatusResponseBodySaleVehiclePhoto[] | undefined
) => (financingStatus ?? []).some((entry) => entry.status === 'PENDING' && !entry.suppressed);
